export default "__VITE_ASSET__DcpfCypy__"